import React, { useEffect, useState } from 'react';
import { dmClient } from '../../services/dmClient';
import './admin.css';

export default function RolesPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    setLoading(true);
    dmClient.get('/roles')
      .then((r) => setItems(r.data?.data?.items || []))
      .catch((e) => setError(e?.response?.data?.error || e.message || 'Failed to load roles'))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="admin-page">
      <div className="admin-head">
        <div>
          <h1>Roles &amp; permissions</h1>
          <p>Built-in roles and the permissions they grant. Assign roles on the Users page.</p>
        </div>
      </div>

      {error && <div className="admin-alert admin-alert--error">{error}</div>}

      <div className="admin-card">
        <table className="admin-table">
          <thead>
            <tr><th>Role</th><th>Description</th><th>Permissions</th></tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan={3} className="admin-empty">Loading…</td></tr>}
            {!loading && items.map((r) => (
              <tr key={r.Name}>
                <td><strong>{r.Name}</strong></td>
                <td>{r.Description || '—'}</td>
                <td>
                  <div className="admin-perms">
                    {(r.permissions || []).map((p) => (
                      <span key={p} className="admin-perm">{p}</span>
                    ))}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
